@import (reference) '../../style.module.less';

.dropdown-toggler {
  @input-text();
  background: var(--left-nav--advanced-search-filter--button-background-color);
  box-shadow: none;
  height: 32px;
  @input-states();

  svg {
    fill: var(--left-nav--advanced-search-filter--dropdown-carret-color);
    width: 8px;
  }
}

.dropdown-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}
